<template>
    <div class="content ht-100v pd-0">
        <div class="content-body pd-10">
            <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                <div>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                            <li class="breadcrumb-item">
                                <router-link to="#">Payslips</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">All Payslips</li>
                        </ol>
                    </nav>
                    <h4 class="mg-b-0 tx-spacing--1">View All Payslips</h4>
                    <p class="tx-color-03 tx-12 mg-b-0">{{auth.userInfo.firstName}} {{auth.userInfo.lastName}}</p>
                    <!--                    <p class="tx-color-03 tx-12 mg-b-0"><strong>Last login:</strong> {{auth.userInfo.userLastLoginDate | moment('dddd, MMMM Do YYYY, h:mm:ss a')}}</p>-->
                </div>
                <div class="d-none d-md-block">
                    <button class="btn btn-sm pd-x-15 btn-white btn-uppercase mg-l-5"  v-b-modal="'payslip-modal'"><plus-icon class="wd-10 mg-r-5" /> Add Payslip</button>
                    <download-excel
                            :data="payslips"
                            class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5">
                        <PrinterIcon class="mg-r-5"/>{{$t('extra.downloadExcel')}}
                    </download-excel>
                    <download-excel
                            type="csv"
                            :data="payslips"
                            class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5">
                        <PrinterIcon class="mg-r-5"/>{{$t('extra.downloadCsv')}}
                    </download-excel>

                </div>
            </div>
            <base-top-cards :carditems="cards"/>
            <hr>

            <base-table
                    :items="payslips"
                    :fields="fields"
                    :show-title="true"
                    :is-busy="payslip.payslipLoading"
                    class="mt-2"
                    filter-mode="balances"
            ></base-table>
        </div>
        <b-modal id="payslip-modal" :hide-header="true" :hide-footer="true" :centered="true" ref="payslip-modal">
            <div class="modal-body">
                <a href="#" role="button" class="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close"
                   @click="hide()">
                    <span aria-hidden="true">&times;</span>
                </a>
                <div>
                    <h4>Add new payslip</h4>
                    <b-form @submit.prevent="createPayslip" enctype="multipart/form-data">
                        <b-form-group label="Code">
                            <b-input required v-model="model.employerPayslipCode"/>
                        </b-form-group>
                        <b-form-group label="Name">
                            <b-input required v-model="model.employerPayslipName"/>
                        </b-form-group>
                        <b-form-group label="Payslip Head">
                            <b-select required v-model="model.employerPayslipHeadId">
                                <b-select-option v-for="employee in employees" :value="employee.employeeId" v-bind:key="employee.employeeId">{{employee.employeeFirstName}} {{employee.employeeMiddleName}} {{employee.employeeLastName}}</b-select-option>
                            </b-select>
                        </b-form-group>
                        <base-button title="Submit" :loading="payslip.payslipLoading"/>
                    </b-form>
                </div>
            </div><!-- modal-body -->
        </b-modal>
    </div>
</template>

<script>
    import BaseTopCards from "../../components/card/BaseTopCards";
    import BaseTable from "../../components/table/BaseTable";
    import BaseButton from "../../components/button/BaseButton";
    import { PrinterIcon, PlusIcon } from 'vue-feather-icons'
    import {mapState} from 'vuex'

    export default {
        name: 'Loan',
        data() {
            return {
                model:{
                    employerPayslipCode: '',
                    employerPayslipEmployerId: '',
                    employerPayslipGroup: 'DEFAULT',
                    employerPayslipHeadId: "",
                    employerPayslipName: ''
                }
                ,
                fields: [
                    { key: 'serial', label: 'S/N', sortable: true, sortDirection: 'desc' },
                    { key: 'employeePayslipEmployeeName', label: 'Employee Name', sortable: true, sortDirection: 'desc' },
                    { key: 'employeePayslipPeriod', label: 'Period', sortable: true, class: 'text-left' },
                    { key: 'employeePayslipAmount', label: 'Amount', sortable: true, class: 'text-left' },
                    { key: 'employeePayslipStatus', label: 'Status', sortable: true, class: 'text-left' },
                    { key: 'employeePayslipCreatedAt', label: 'Created Date', sortable: true, class: 'text-left' },
                    { key: 'actionsCalender', label: 'Action', sortable: true, class: 'text-center' }
                ],
            }
        },
        components: {
            PlusIcon,
            BaseButton,
            BaseTable,
            BaseTopCards,
            PrinterIcon,


        },
        computed: {
            cards:{
                get(){
                    return [
                        {
                            id: 0,
                            name: 'Total Payslips',
                            number: this.payslips.length,// == null?'0.00':'GHS '+this.numberWithCommas(this.totalGhs),
                            color: 'bg-primary'
                        },
                        {
                            id: 1,
                            name: 'PAID Payslips',
                            number: this.payslips.filter(it => it.employeePayslipStatus.toUpperCase() === 'PAID').length,// == null?'0.00':'GBP '+this.numberWithCommas(this.totalGbp),
                            color: 'bg-orange'
                        },
                        {
                            id: 2,
                            name: 'Pending Payslips',
                            number: this.payslips.filter(it => it.employeePayslipStatus.toUpperCase() === 'PENDING').length,// == null?'0.00':'USD '+this.numberWithCommas(this.totalUsd),
                            color: 'bg-success'
                        },
                        {
                            id: 3,
                            name: 'Suspended Payslips',
                            number: this.payslips.filter(it => it.employeePayslipStatus.toUpperCase() === 'SUSPENDED').length,// == null?'0.00':'EUR '+this.numberWithCommas(this.totalEur),
                            color: 'bg-black-8'
                        }
                    ]
                },
                set(){

                }
            },
            payslips(){
                return  this.payslip.payslips
            },
            authobj: function () {
                return this.$store.state.auth.response
            },
            employees(){
                return  this.employee.employees?this.employee.employees:[]
            },
            ...mapState([
                'employee',
                'payslip',
                'auth'
            ])
        },
        methods: {
            async createPayslip(){
                this.model.employerPayslipEmployerId = localStorage.orgID
                await this.$store.dispatch("payslip/createPayslip", this.model, {root: false})
                this.loadPayslip();
                this.hide();
                let self = this;
                // eslint-disable-next-line no-unused-vars
                Object.keys(this.model).forEach(function(key,index) {
                    self.model[key] = '';
                });

            },
            loadPayslip(){
                this.$store.dispatch("payslip/updatePayslips", {
                    readAll:'NO',
                    employerId: localStorage.orgID
                }, {root: false}).then()
            },
            hide() {
                this.$refs['payslip-modal'].hide()
            },
            numberWithCommas(x) {
                let parts = x.toString().split(".");
                if (parts[1] == null)  parts[1] = '00'
                else if (parts[1].length === 0) parts[1] = parts[1]+'00'
                else if (parts[1].length === 1) parts[1] = parts[1]+'0'
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return parts.join(".");
            },
        },
        created() {
            this.$store.dispatch("employee/updateEmployees", {
                readAll:'NO',
                employerId: localStorage.orgID
            }, {root: false}).then()
            this.$store.dispatch("payslip/updatePayslips", {
                readAll:'YES',
                employeePayslipEmployeeId: localStorage.orgID
            }, {root: false}).then()
        }
    }


</script>

<style scoped>

</style>
